var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cardData)?_c('oki-card-upload-form',{ref:"form",attrs:{"card-data":_vm.cardData,"image":_vm.getImage,"visited-summary":_vm.visitedSummary,"bank-account-number":_vm.financialData && _vm.financialData.residentialBankAccountNumber},on:{"save-images":_vm.postData,"on-delete-image":_vm.deleteImage}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }